// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hotel-table {
  width: 100%;
  border-collapse: collapse;
  font-family: inherit;
}

.table-header {
  background-color: #f8fafc;
  padding: 16px 20px;
  text-align: left;
  font-weight: 600;
  font-size: 14px;
  color: #374151;
  border-bottom: 2px solid #e5e7eb;
  white-space: nowrap;
  position: sticky;
  top: 0;
  z-index: 10;
}

.table-header.sortable {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: all 0.2s ease;
  position: relative;
  background-color: #f8fafc;
  color: #374151;
}

.table-header.sortable:hover {
  background-color: #f1f5f9;
  color: #F37032;
}

.table-header.sortable:active {
  transform: scale(0.98);
}

.checkbox-header {
  width: 60px;
  text-align: center;
}

.table-row {
  border-bottom: 1px solid #e5e7eb;
  transition: all 0.2s ease;
}

.table-row:hover {
  background-color: #f8fafc;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.table-cell {
  padding: 16px 20px;
  font-size: 14px;
  color: #374151;
  border-bottom: 1px solid #e5e7eb;
  vertical-align: middle;
  line-height: 1.5;
}

.checkbox-cell {
  width: 60px;
  text-align: center;
}

.actions-cell {
  width: 140px;
  text-align: center;
}

.actions-cell .icon-button {
  padding: 8px;
  border-radius: 8px;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.actions-cell .icon-button:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* Mobile responsive adjustments */
@media (max-width: 768px) {
  .hotel-table {
    font-size: 12px;
  }
  
  .table-header,
  .table-cell {
    padding: 12px 16px;
  }
  
  .actions-cell {
    width: 120px;
  }
}

/* Checkbox styling */
.hotel-table .checkbox {
  margin: 0;
}

.hotel-table .checkbox__control {
  border-radius: 6px;
  border: 2px solid #d1d5db;
  background-color: white;
  width: 18px;
  height: 18px;
  transition: all 0.2s ease;
}

.hotel-table .checkbox__control:hover {
  border-color: #F37032;
  transform: scale(1.05);
}

.hotel-table .checkbox__control[data-checked="true"] {
  background-color: #F37032;
  border-color: #F37032;
  box-shadow: 0 2px 4px rgba(243, 112, 50, 0.2);
}

.hotel-table .checkbox__icon {
  color: white;
  font-size: 12px;
}

/* Input styling */
.hotel-table-container .input {
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  padding: 12px 16px;
  font-size: 14px;
  transition: all 0.2s ease;
  background-color: white;
}

.hotel-table-container .input:focus {
  border-color: #F37032;
  outline: none;
  box-shadow: 0 0 0 3px rgba(243, 112, 50, 0.1);
  transform: translateY(-1px);
}

/* Button styling */
.hotel-table-container .custom-button {
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.2s ease;
  padding: 12px 24px;
}

.hotel-table-container .custom-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
}

/* Enhanced table styling */
.hotel-table tbody tr:last-child {
  border-bottom: none;
}

.hotel-table tbody tr:first-child {
  border-top: 1px solid #e5e7eb;
}

/* Sort icon styling */
.sortable svg {
  transition: all 0.2s ease;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.sortable:hover svg {
  transform: scale(1.1);
}

/* Ensure consistent header text and icon alignment */
.table-header.sortable .hstack {
  align-items: center;
  gap: 8px;
}

.table-header.sortable .hstack svg {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

/* Card styling for mobile */
.hotel-card {
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.2s ease;
}

.hotel-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

/* Action buttons styling */
.action-button {
  padding: 8px;
  border-radius: 8px;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.action-button:hover {
  transform: scale(1.05);
}

.action-button.edit {
  background-color: rgba(243, 112, 50, 0.1);
}

.action-button.delete {
  background-color: rgba(239, 68, 68, 0.1);
}

/* Dishes breakdown styling */
.dishes-breakdown {
  font-size: 11px;
  color: #6b7280;
  line-height: 1.4;
}

.dishes-breakdown .dish-item {
  margin-bottom: 2px;
}

/* Rate styling */
.rate-amount {
  color: #F37032;
  font-weight: 600;
}

/* Empty state styling */
.empty-state {
  padding: 48px 24px;
  text-align: center;
  color: #6b7280;
}

.empty-state svg {
  margin-bottom: 16px;
  opacity: 0.5;
}

/* Loading state */
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 32px;
}

/* Scrollbar styling */
.hotel-table-container::-webkit-scrollbar,
.hotel-table::-webkit-scrollbar {
  width: 0px;
  height: 0px;
  display: none;
}

.hotel-table-container::-webkit-scrollbar-track,
.hotel-table::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 0px;
}

.hotel-table-container::-webkit-scrollbar-thumb,
.hotel-table::-webkit-scrollbar-thumb {
  background: transparent;
  border-radius: 0px;
}

.hotel-table-container::-webkit-scrollbar-thumb:hover,
.hotel-table::-webkit-scrollbar-thumb:hover {
  background: transparent;
}

/* Hide scrollbar for Firefox */
.hotel-table-container,
.hotel-table {
  scrollbar-width: none;
  -ms-overflow-style: none;
}

/* Hide scrollbar for the new table structure */
.hotel-table-container::-webkit-scrollbar,
.hotel-table::-webkit-scrollbar,
.hotel-table-container div::-webkit-scrollbar,
.hotel-table-container table::-webkit-scrollbar {
  width: 0px;
  height: 0px;
  display: none;
}

.hotel-table-container div::-webkit-scrollbar-track,
.hotel-table-container table::-webkit-scrollbar-track {
  background: transparent;
}

.hotel-table-container div::-webkit-scrollbar-thumb,
.hotel-table-container table::-webkit-scrollbar-thumb {
  background: transparent;
}

/* New table structure styling */
.hotel-table {
  table-layout: fixed;
  width: 100%;
}

/* Column width definitions for better layout */
.hotel-table th:nth-child(1),
.hotel-table td:nth-child(1) {
  width: 60px; /* Checkbox column - MINIMUM WIDTH */
  min-width: 60px;
}

.hotel-table th:nth-child(2),
.hotel-table td:nth-child(2) {
  width: 13%; /* Hotel Name & Chain - SLIGHTLY INCREASED */
  min-width: 150px;
}

.hotel-table th:nth-child(3),
.hotel-table td:nth-child(3) {
  width: 18%; /* Venue & City - REDUCED */
  min-width: 160px;
}

.hotel-table th:nth-child(4),
.hotel-table td:nth-child(4) {
  width: 19%; /* SPOC Details - INCREASED */
  min-width: 220px;
}

.hotel-table th:nth-child(5),
.hotel-table td:nth-child(5) {
  width: 8%; /* Cluster - REDUCED */
  min-width: 80px;
}

.hotel-table th:nth-child(6),
.hotel-table td:nth-child(6) {
  width: 8%; /* Theatre - REDUCED */
  min-width: 80px;
}

.hotel-table th:nth-child(7),
.hotel-table td:nth-child(7) {
  width: 24%; /* Head Count & Rate - INCREASED */
  min-width: 300px;
}

.hotel-table th:nth-child(8),
.hotel-table td:nth-child(8) {
  width: 20%; /* Dishes - INCREASED */
  min-width: 280px;
}

.hotel-table th:nth-child(9),
.hotel-table td:nth-child(9) {
  width: 10%; /* Remarks */
  min-width: 120px;
}

.hotel-table th:nth-child(10),
.hotel-table td:nth-child(10) {
  width: 100px; /* Actions - MINIMUM WIDTH */
  min-width: 100px;
}

/* Enhanced cell styling for combined columns */
.hotel-table td {
  vertical-align: top;
  text-align: left;
  padding: 16px 12px;
}

.hotel-table td .vstack {
  gap: 4px;
}

/* Primary text styling */
.hotel-table td .primary-text {
  font-weight: 600;
  color: #1f2937;
  font-size: 14px;
  line-height: 1.4;
}

/* Secondary text styling */
.hotel-table td .secondary-text {
  font-weight: 400;
  color: #6b7280;
  font-size: 12px;
  line-height: 1.3;
}

/* Head Count & Rate column specific styling */
.hotel-table td:nth-child(7) .vstack {
  gap: 8px;
}

/* Dishes column specific styling */
.hotel-table td:nth-child(8) .vstack {
  gap: 8px;
}

/* Allow text wrapping in other columns */
.hotel-table td:nth-child(2),
.hotel-table td:nth-child(3),
.hotel-table td:nth-child(4) {
  word-wrap: break-word;
  white-space: normal;
  line-height: 1.4;
}

/* Responsive adjustments for new structure */
@media (max-width: 1200px) {
  .hotel-table th:nth-child(2),
  .hotel-table td:nth-child(2) {
    width: 17%; /* Hotel Name & Chain - ADJUSTED */
    min-width: 160px;
  }
  
  .hotel-table th:nth-child(3),
  .hotel-table td:nth-child(3) {
    width: 14%; /* Venue & City - ADJUSTED */
    min-width: 150px;
  }
  
  .hotel-table th:nth-child(4),
  .hotel-table td:nth-child(4) {
    width: 20%; /* SPOC Details - INCREASED */
    min-width: 200px;
  }
  
  .hotel-table th:nth-child(5),
  .hotel-table td:nth-child(5) {
    width: 8%; /* Cluster - REDUCED */
    min-width: 70px;
  }
  
  .hotel-table th:nth-child(6),
  .hotel-table td:nth-child(6) {
    width: 8%; /* Theatre - REDUCED */
    min-width: 70px;
  }
  
  .hotel-table th:nth-child(7),
  .hotel-table td:nth-child(7) {
    width: 22%; /* Head Count & Rate */
    min-width: 280px;
  }
  
  .hotel-table th:nth-child(8),
  .hotel-table td:nth-child(8) {
    width: 18%; /* Dishes */
    min-width: 260px;
  }
  
  /* Keep minimum widths for fixed columns */
  .hotel-table th:nth-child(1),
  .hotel-table td:nth-child(1) {
    width: 60px;
    min-width: 60px;
  }
  
  .hotel-table th:nth-child(5),
  .hotel-table td:nth-child(5) {
    width: 100px;
    min-width: 100px;
  }
  
  .hotel-table th:nth-child(6),
  .hotel-table td:nth-child(6) {
    width: 100px;
    min-width: 100px;
  }
  
  .hotel-table th:nth-child(10),
  .hotel-table td:nth-child(10) {
    width: 100px;
    min-width: 100px;
  }
}

@media (max-width: 768px) {
  .hotel-table {
    table-layout: auto;
  }
  
  .hotel-table th,
  .hotel-table td {
    width: auto !important;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/HotelTable/style.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gCAAgC;EAChC,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA,kCAAkC;AAClC;EACE;IACE,eAAe;EACjB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA,qBAAqB;AACrB;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,sBAAsB;AACtB;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,qDAAqD;AACrD;EACE,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA,2BAA2B;AAC3B;EACE,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA,sBAAsB;AACtB;;EAEE,UAAU;EACV,WAAW;EACX,aAAa;AACf;;AAEA;;EAEE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;;EAEE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA,+BAA+B;AAC/B;;EAEE,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA,+CAA+C;AAC/C;;;;EAIE,UAAU;EACV,WAAW;EACX,aAAa;AACf;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA,gCAAgC;AAChC;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,+CAA+C;AAC/C;;EAEE,WAAW,EAAE,oCAAoC;EACjD,eAAe;AACjB;;AAEA;;EAEE,UAAU,EAAE,4CAA4C;EACxD,gBAAgB;AAClB;;AAEA;;EAEE,UAAU,EAAE,2BAA2B;EACvC,gBAAgB;AAClB;;AAEA;;EAEE,UAAU,EAAE,6BAA6B;EACzC,gBAAgB;AAClB;;AAEA;;EAEE,SAAS,EAAE,sBAAsB;EACjC,eAAe;AACjB;;AAEA;;EAEE,SAAS,EAAE,sBAAsB;EACjC,eAAe;AACjB;;AAEA;;EAEE,UAAU,EAAE,kCAAkC;EAC9C,gBAAgB;AAClB;;AAEA;;EAEE,UAAU,EAAE,uBAAuB;EACnC,gBAAgB;AAClB;;AAEA;;EAEE,UAAU,EAAE,YAAY;EACxB,gBAAgB;AAClB;;AAEA;;EAEE,YAAY,EAAE,4BAA4B;EAC1C,gBAAgB;AAClB;;AAEA,+CAA+C;AAC/C;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,QAAQ;AACV;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,8CAA8C;AAC9C;EACE,QAAQ;AACV;;AAEA,mCAAmC;AACnC;EACE,QAAQ;AACV;;AAEA,yCAAyC;AACzC;;;EAGE,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,6CAA6C;AAC7C;EACE;;IAEE,UAAU,EAAE,kCAAkC;IAC9C,gBAAgB;EAClB;;EAEA;;IAEE,UAAU,EAAE,4BAA4B;IACxC,gBAAgB;EAClB;;EAEA;;IAEE,UAAU,EAAE,6BAA6B;IACzC,gBAAgB;EAClB;;EAEA;;IAEE,SAAS,EAAE,sBAAsB;IACjC,eAAe;EACjB;;EAEA;;IAEE,SAAS,EAAE,sBAAsB;IACjC,eAAe;EACjB;;EAEA;;IAEE,UAAU,EAAE,sBAAsB;IAClC,gBAAgB;EAClB;;EAEA;;IAEE,UAAU,EAAE,WAAW;IACvB,gBAAgB;EAClB;;EAEA,0CAA0C;EAC1C;;IAEE,WAAW;IACX,eAAe;EACjB;;EAEA;;IAEE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;;IAEE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;;IAEE,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;;IAEE,sBAAsB;EACxB;AACF","sourcesContent":[".hotel-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-family: inherit;\n}\n\n.table-header {\n  background-color: #f8fafc;\n  padding: 16px 20px;\n  text-align: left;\n  font-weight: 600;\n  font-size: 14px;\n  color: #374151;\n  border-bottom: 2px solid #e5e7eb;\n  white-space: nowrap;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n}\n\n.table-header.sortable {\n  cursor: pointer;\n  user-select: none;\n  transition: all 0.2s ease;\n  position: relative;\n  background-color: #f8fafc;\n  color: #374151;\n}\n\n.table-header.sortable:hover {\n  background-color: #f1f5f9;\n  color: #F37032;\n}\n\n.table-header.sortable:active {\n  transform: scale(0.98);\n}\n\n.checkbox-header {\n  width: 60px;\n  text-align: center;\n}\n\n.table-row {\n  border-bottom: 1px solid #e5e7eb;\n  transition: all 0.2s ease;\n}\n\n.table-row:hover {\n  background-color: #f8fafc;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.table-cell {\n  padding: 16px 20px;\n  font-size: 14px;\n  color: #374151;\n  border-bottom: 1px solid #e5e7eb;\n  vertical-align: middle;\n  line-height: 1.5;\n}\n\n.checkbox-cell {\n  width: 60px;\n  text-align: center;\n}\n\n.actions-cell {\n  width: 140px;\n  text-align: center;\n}\n\n.actions-cell .icon-button {\n  padding: 8px;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.actions-cell .icon-button:hover {\n  transform: scale(1.05);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n/* Mobile responsive adjustments */\n@media (max-width: 768px) {\n  .hotel-table {\n    font-size: 12px;\n  }\n  \n  .table-header,\n  .table-cell {\n    padding: 12px 16px;\n  }\n  \n  .actions-cell {\n    width: 120px;\n  }\n}\n\n/* Checkbox styling */\n.hotel-table .checkbox {\n  margin: 0;\n}\n\n.hotel-table .checkbox__control {\n  border-radius: 6px;\n  border: 2px solid #d1d5db;\n  background-color: white;\n  width: 18px;\n  height: 18px;\n  transition: all 0.2s ease;\n}\n\n.hotel-table .checkbox__control:hover {\n  border-color: #F37032;\n  transform: scale(1.05);\n}\n\n.hotel-table .checkbox__control[data-checked=\"true\"] {\n  background-color: #F37032;\n  border-color: #F37032;\n  box-shadow: 0 2px 4px rgba(243, 112, 50, 0.2);\n}\n\n.hotel-table .checkbox__icon {\n  color: white;\n  font-size: 12px;\n}\n\n/* Input styling */\n.hotel-table-container .input {\n  border: 2px solid #e5e7eb;\n  border-radius: 12px;\n  padding: 12px 16px;\n  font-size: 14px;\n  transition: all 0.2s ease;\n  background-color: white;\n}\n\n.hotel-table-container .input:focus {\n  border-color: #F37032;\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(243, 112, 50, 0.1);\n  transform: translateY(-1px);\n}\n\n/* Button styling */\n.hotel-table-container .custom-button {\n  border-radius: 8px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  padding: 12px 24px;\n}\n\n.hotel-table-container .custom-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);\n}\n\n/* Enhanced table styling */\n.hotel-table tbody tr:last-child {\n  border-bottom: none;\n}\n\n.hotel-table tbody tr:first-child {\n  border-top: 1px solid #e5e7eb;\n}\n\n/* Sort icon styling */\n.sortable svg {\n  transition: all 0.2s ease;\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n}\n\n.sortable:hover svg {\n  transform: scale(1.1);\n}\n\n/* Ensure consistent header text and icon alignment */\n.table-header.sortable .hstack {\n  align-items: center;\n  gap: 8px;\n}\n\n.table-header.sortable .hstack svg {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n}\n\n/* Card styling for mobile */\n.hotel-card {\n  border-radius: 16px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n  transition: all 0.2s ease;\n}\n\n.hotel-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n}\n\n/* Action buttons styling */\n.action-button {\n  padding: 8px;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.action-button:hover {\n  transform: scale(1.05);\n}\n\n.action-button.edit {\n  background-color: rgba(243, 112, 50, 0.1);\n}\n\n.action-button.delete {\n  background-color: rgba(239, 68, 68, 0.1);\n}\n\n/* Dishes breakdown styling */\n.dishes-breakdown {\n  font-size: 11px;\n  color: #6b7280;\n  line-height: 1.4;\n}\n\n.dishes-breakdown .dish-item {\n  margin-bottom: 2px;\n}\n\n/* Rate styling */\n.rate-amount {\n  color: #F37032;\n  font-weight: 600;\n}\n\n/* Empty state styling */\n.empty-state {\n  padding: 48px 24px;\n  text-align: center;\n  color: #6b7280;\n}\n\n.empty-state svg {\n  margin-bottom: 16px;\n  opacity: 0.5;\n}\n\n/* Loading state */\n.loading-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 32px;\n}\n\n/* Scrollbar styling */\n.hotel-table-container::-webkit-scrollbar,\n.hotel-table::-webkit-scrollbar {\n  width: 0px;\n  height: 0px;\n  display: none;\n}\n\n.hotel-table-container::-webkit-scrollbar-track,\n.hotel-table::-webkit-scrollbar-track {\n  background: transparent;\n  border-radius: 0px;\n}\n\n.hotel-table-container::-webkit-scrollbar-thumb,\n.hotel-table::-webkit-scrollbar-thumb {\n  background: transparent;\n  border-radius: 0px;\n}\n\n.hotel-table-container::-webkit-scrollbar-thumb:hover,\n.hotel-table::-webkit-scrollbar-thumb:hover {\n  background: transparent;\n}\n\n/* Hide scrollbar for Firefox */\n.hotel-table-container,\n.hotel-table {\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n/* Hide scrollbar for the new table structure */\n.hotel-table-container::-webkit-scrollbar,\n.hotel-table::-webkit-scrollbar,\n.hotel-table-container div::-webkit-scrollbar,\n.hotel-table-container table::-webkit-scrollbar {\n  width: 0px;\n  height: 0px;\n  display: none;\n}\n\n.hotel-table-container div::-webkit-scrollbar-track,\n.hotel-table-container table::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.hotel-table-container div::-webkit-scrollbar-thumb,\n.hotel-table-container table::-webkit-scrollbar-thumb {\n  background: transparent;\n}\n\n/* New table structure styling */\n.hotel-table {\n  table-layout: fixed;\n  width: 100%;\n}\n\n/* Column width definitions for better layout */\n.hotel-table th:nth-child(1),\n.hotel-table td:nth-child(1) {\n  width: 60px; /* Checkbox column - MINIMUM WIDTH */\n  min-width: 60px;\n}\n\n.hotel-table th:nth-child(2),\n.hotel-table td:nth-child(2) {\n  width: 13%; /* Hotel Name & Chain - SLIGHTLY INCREASED */\n  min-width: 150px;\n}\n\n.hotel-table th:nth-child(3),\n.hotel-table td:nth-child(3) {\n  width: 18%; /* Venue & City - REDUCED */\n  min-width: 160px;\n}\n\n.hotel-table th:nth-child(4),\n.hotel-table td:nth-child(4) {\n  width: 19%; /* SPOC Details - INCREASED */\n  min-width: 220px;\n}\n\n.hotel-table th:nth-child(5),\n.hotel-table td:nth-child(5) {\n  width: 8%; /* Cluster - REDUCED */\n  min-width: 80px;\n}\n\n.hotel-table th:nth-child(6),\n.hotel-table td:nth-child(6) {\n  width: 8%; /* Theatre - REDUCED */\n  min-width: 80px;\n}\n\n.hotel-table th:nth-child(7),\n.hotel-table td:nth-child(7) {\n  width: 24%; /* Head Count & Rate - INCREASED */\n  min-width: 300px;\n}\n\n.hotel-table th:nth-child(8),\n.hotel-table td:nth-child(8) {\n  width: 20%; /* Dishes - INCREASED */\n  min-width: 280px;\n}\n\n.hotel-table th:nth-child(9),\n.hotel-table td:nth-child(9) {\n  width: 10%; /* Remarks */\n  min-width: 120px;\n}\n\n.hotel-table th:nth-child(10),\n.hotel-table td:nth-child(10) {\n  width: 100px; /* Actions - MINIMUM WIDTH */\n  min-width: 100px;\n}\n\n/* Enhanced cell styling for combined columns */\n.hotel-table td {\n  vertical-align: top;\n  text-align: left;\n  padding: 16px 12px;\n}\n\n.hotel-table td .vstack {\n  gap: 4px;\n}\n\n/* Primary text styling */\n.hotel-table td .primary-text {\n  font-weight: 600;\n  color: #1f2937;\n  font-size: 14px;\n  line-height: 1.4;\n}\n\n/* Secondary text styling */\n.hotel-table td .secondary-text {\n  font-weight: 400;\n  color: #6b7280;\n  font-size: 12px;\n  line-height: 1.3;\n}\n\n/* Head Count & Rate column specific styling */\n.hotel-table td:nth-child(7) .vstack {\n  gap: 8px;\n}\n\n/* Dishes column specific styling */\n.hotel-table td:nth-child(8) .vstack {\n  gap: 8px;\n}\n\n/* Allow text wrapping in other columns */\n.hotel-table td:nth-child(2),\n.hotel-table td:nth-child(3),\n.hotel-table td:nth-child(4) {\n  word-wrap: break-word;\n  white-space: normal;\n  line-height: 1.4;\n}\n\n/* Responsive adjustments for new structure */\n@media (max-width: 1200px) {\n  .hotel-table th:nth-child(2),\n  .hotel-table td:nth-child(2) {\n    width: 17%; /* Hotel Name & Chain - ADJUSTED */\n    min-width: 160px;\n  }\n  \n  .hotel-table th:nth-child(3),\n  .hotel-table td:nth-child(3) {\n    width: 14%; /* Venue & City - ADJUSTED */\n    min-width: 150px;\n  }\n  \n  .hotel-table th:nth-child(4),\n  .hotel-table td:nth-child(4) {\n    width: 20%; /* SPOC Details - INCREASED */\n    min-width: 200px;\n  }\n  \n  .hotel-table th:nth-child(5),\n  .hotel-table td:nth-child(5) {\n    width: 8%; /* Cluster - REDUCED */\n    min-width: 70px;\n  }\n  \n  .hotel-table th:nth-child(6),\n  .hotel-table td:nth-child(6) {\n    width: 8%; /* Theatre - REDUCED */\n    min-width: 70px;\n  }\n  \n  .hotel-table th:nth-child(7),\n  .hotel-table td:nth-child(7) {\n    width: 22%; /* Head Count & Rate */\n    min-width: 280px;\n  }\n  \n  .hotel-table th:nth-child(8),\n  .hotel-table td:nth-child(8) {\n    width: 18%; /* Dishes */\n    min-width: 260px;\n  }\n  \n  /* Keep minimum widths for fixed columns */\n  .hotel-table th:nth-child(1),\n  .hotel-table td:nth-child(1) {\n    width: 60px;\n    min-width: 60px;\n  }\n  \n  .hotel-table th:nth-child(5),\n  .hotel-table td:nth-child(5) {\n    width: 100px;\n    min-width: 100px;\n  }\n  \n  .hotel-table th:nth-child(6),\n  .hotel-table td:nth-child(6) {\n    width: 100px;\n    min-width: 100px;\n  }\n  \n  .hotel-table th:nth-child(10),\n  .hotel-table td:nth-child(10) {\n    width: 100px;\n    min-width: 100px;\n  }\n}\n\n@media (max-width: 768px) {\n  .hotel-table {\n    table-layout: auto;\n  }\n  \n  .hotel-table th,\n  .hotel-table td {\n    width: auto !important;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
